export const namespaced = true;

import AdvanceStudentService from '@/services/AdvanceStudentService.js';

export const state = {
  advanceStudents: [],
};

export const mutations = {
  SET_ADVANCE_STUDENTS(state, advanceStudents) {
    state.advanceStudents = advanceStudents;
  },
};

export const actions = {
  fetchAdvanceStudents({ commit }) {
    return AdvanceStudentService.all().then((response) => {
      commit('SET_ADVANCE_STUDENTS', response.data || []);
    });
  },
};

export const getters = {
  getAdvanceStudentById: (state) => (id) => {
    return state.advanceStudents.find((item) => item.id == id);
  },
  totalAdvanceStudents: (state) => {
    return state.advanceStudents.length;
  },
};
